<documento [data]="data" (fecharModal)="fecharModal($event)"></documento>